// Social Icons Imports
import allSparkData from '../assets/data/allspark.json';
import {
  faFacebookF,
  faTwitter,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

export const TimeConstants = {
  minutes: 'Minutes',
  IST: 'IST',
};
export const COMMONS = {
  EVENTS: 'Events',
};

// Social Icons Starts
const { facebook, twitter, instagram } = allSparkData['links'];

export const SOCIAL_ICONS = [
  { icon: faFacebookF, link: facebook },
  { icon: faTwitter, link: twitter },
  { icon: faInstagram, link: instagram },
];

// Social Icons Ends

// Category Card component constants

export const CATEGORY_CARD_CONSTANTS = {
  VIEW_SCHEDULE: 'View Schedule',
  TITLE: 'Category Title',
  DESCRIPTION: 'Category Description',
  DATE: 'Event Date',
  FALLBACK_IMAGE: 'Category Image',
};

// Breakpoints for handling Responsiveness
export const VIEWPORT_BREAKPOINTS = {
  SMALL_SIZE_MOBILE_DEVICES: 576,
  MEDIUM_SIZE_MOBILE_DEVICES: 768,
  LARGE_SIZE_MOBILE_DEVICES: 992,
  SMALL_SIZE_DESKTOP_DEVICES: 1280,
};

export const IMAGE_ALT = {
  ALL_SPARK: 'AllSpark Logo',
  SIRIUS: 'Sirius Logo',
};

export const THEME = {
  LIGHT : 'light',
  DARK : 'dark'
}

export const TIME_NOTE = {
  note : "*All timings mentioned below are in IST"
}

export const Repeat ={
  REPEAT : " - Repeat"
}